// extracted by mini-css-extract-plugin
module.exports = {"empty":"empty_empty__sC8_m","pulse":"empty_pulse__hwAVj","ripple":"empty_ripple__v7DTZ","title":"empty_title__nhlRv","sub":"empty_sub___6Mf_"};